
/**
 * 
 * @param {string} str 
 */
export function checkLiterals(str){
    return /^[A-Za-z_]+$/.test(str);
}

